import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../apiSetup/apiCall";

export const submitEditCouponData = createAsyncThunk(
  "submitCouponAdmin/fetchCouponSubmitAdmin",
  async ({ couponId, payload }) => {
    try {
      const response = await api.post(
        `prometheus/station/edit/coupon/${couponId}/`,
        payload
      );
      return response.data;
    } catch (error) {
      console.error("Error Submitting Data:", error);
      return error.response.data;
    }
  }
);

const SubmitEditCouponSlice = createSlice({
  name: "submitEditCoupon",
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(submitEditCouponData.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(submitEditCouponData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(submitEditCouponData.rejected, (state, action) => {
        state.isLoading = false;
      });
  },
});

export default SubmitEditCouponSlice.reducer;
